import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { Cmi5Course } from '@/apiTypes/Cmi5Types';
import { lessonPlayerPath } from './lessonRoutes';

export const useLaunchLesson = () => {
    const navigate = useNavigate();

    return useCallback((course: Cmi5Course) => {
        navigate(lessonPlayerPath(course.id));
    }, [navigate]);
};
